<template>
  <button
    class="notification-bell"
    :class="{ 'is-active': isNotificationPanelActive }"
    :aria-label="$t('SIDEBAR.NOTIFICATIONS')"
    @click="openNotificationPanel"
  >
    <nav-icon :src="bellIcon" />
    <span
      v-if="unreadCount"
      class="text-black-900 bg-yellow-300 absolute top-1 ltr:right-1 rtl:left-1 p-1 text-xxs min-w-[1rem] leading-none rounded-full"
    >
      {{ unreadCount }}
    </span>
  </button>
</template>
<script>
import { mapGetters } from 'vuex';
import NavIcon from './NavIcon.vue';
import bellIcon from 'dashboard/assets/images/sidebar/bell.svg';

export default {
  components: { NavIcon },
  data() {
    return {
      bellIcon,
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      notificationMetadata: 'notifications/getMeta',
    }),
    unreadCount() {
      if (!this.notificationMetadata.unreadCount) {
        return '';
      }

      return this.notificationMetadata.unreadCount < 100
        ? `${this.notificationMetadata.unreadCount}`
        : '99+';
    },
    isNotificationPanelActive() {
      return this.$route.name === 'notifications_index';
    },
  },
  methods: {
    openNotificationPanel() {
      if (this.$route.name !== 'notifications_index') {
        this.$emit('open-notification-panel');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.notification-bell {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 5px;
  color: #6b7280;

  &:hover {
    background: #f3f4f6;
  }

  &.is-active {
    background: #f0fdf4;
    color: #164b35;
  }
}
</style>
